<template>
  <v-row>
    <v-col cols="4" class="text-center pa-0 ma-0">
      <v-row justify="center">
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="adicionalesIzquierda"
            label="6. Axila"
            :value="6"
            dense
            hide-details
          />
          <v-checkbox
            v-model="adicionalesIzquierda"
            label="7. Hueco supra clavicular"
            :value="7"
            dense
            hide-details
          />
          <v-checkbox
            v-model="adicionalesIzquierda"
            label="8. Mama derecha"
            :value="8"
            dense
            hide-details
          />
        </v-col>
      </v-row>

      <CircularPicker
        v-model="seleccionIzquierda"
        :labels="labelIzquierda"
      />
    </v-col>

    <v-col cols="4">
      <v-img
        src="/img/diagrama_pecho.png"
        class="overlay"
        max-height="300px"
        contain
      />
    </v-col>

    <v-col cols="4" class="text-center pa-0 ma-0">
      <v-row justify="center">
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="adicionalesDerecha"
            label="14. Axila"
            :value="14"
            dense
            hide-details
          />
          <v-checkbox
            v-model="adicionalesDerecha"
            label="15. Hueco supra clavicular"
            :value="15"
            dense
            hide-details
          />
          <v-checkbox
            v-model="adicionalesDerecha"
            label="16. Mama izquierda"
            :value="16"
            dense
            hide-details
          />
        </v-col>
      </v-row>

      <CircularPicker
        v-model="seleccionDerecha"
        :labels="labelDerecha"
      />
    </v-col>
  </v-row>
</template>

<script>
import CircularPicker from '@/components/CircularPicker.vue'

export default {
  name: 'PechoSelector',
  components: { CircularPicker },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      seleccionIzquierda: [],
      seleccionDerecha: [],
      adicionalesIzquierda: [],
      adicionalesDerecha: [],
      labelIzquierda: ['4', '3', '1', '2', '5'],
      labelDerecha: ['10', '11', '12', '9', '13'],
    };
  },
  watch: {
    seleccionIzquierda: 'emitSelection',
    seleccionDerecha: 'emitSelection',
    adicionalesIzquierda: 'emitSelection',
    adicionalesDerecha: 'emitSelection'
  },
  methods: {
    emitSelection() {
      const combined = this.seleccionIzquierda.map(i => parseInt(this.labelIzquierda[i - 1]))
        .concat(this.seleccionDerecha.map(i => parseInt(this.labelDerecha[i - 1])))
        .concat(this.adicionalesIzquierda)
        .concat(this.adicionalesDerecha)
        .sort((a, b) => a - b);

      this.$emit('input', combined);
    },
    clear(){
      this.seleccionDerecha = [];
      this.seleccionIzquierda = [];
      this.adicionalesIzquierda = [];
      this.adicionalesDerecha = [];
    }
  }
};
</script>
